import type React from 'react';
import { useEffect, useState } from 'react';
import findIndex from 'lodash/findIndex';
import { createPortal } from 'react-dom';

import { ControlPosition } from 'src/components/map/GoogleMap';

export type GoogleMapControlProps = {
    containerId: string;
    children?: React.ReactNode;
    position?: ControlPosition;
    zIndex?: number;
    map: google.maps.Map;
    width?: string;
    height?: string;
};

const GoogleMapControl = ({
    containerId,
    children,
    position = ControlPosition.TOP_CENTER,
    zIndex = 0,
    map,
    width,
    height,
}: GoogleMapControlProps): React.ReactPortal => {
    const [container] = useState(document.createElement('div'));

    useEffect(() => {
        container.id = containerId;
        if (width) {
            container.style.width = width;
        }
        if (height) {
            container.style.height = height;
        }
        return () => {
            const controls = map.controls[position];
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
            const index = findIndex(controls as any, ['id', containerId]);
            if (index !== -1) {
                controls.removeAt(index);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const controlsContainer = map.controls[position];
        controlsContainer.push(container);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map]);

    useEffect(() => {
        container.style.zIndex = String(zIndex);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zIndex]);

    return createPortal(children, container);
};

export default GoogleMapControl;
